import React from 'react';

import { CustomCellRendererProps } from 'ag-grid-react';

import styles from './ProductSupplierRenderer.module.scss';

const ProductSupplierRenderer = (
  params: CustomCellRendererProps<{ value: { supplierCode: string; supplierName: string }[] }>
) => {
  if (params.value.length === 0) {
    return <div className={styles['suppliers-cell-renderer']}>{'-'}</div>;
  }

  return (
    <div className={styles['suppliers-cell-renderer']}>
      <span className={styles['supplier-name']}>
        {params.value[0].supplierName ? params.value[0].supplierName : '-'}
      </span>
      {params.value.length > 1 && (
        <span className={styles['supplier-count']}>&nbsp;{`외 ${params.value.length - 1}건`}</span>
      )}
    </div>
  );
};

export default ProductSupplierRenderer;
